import { areIntervalsOverlapping, subWeeks } from 'date-fns';
import z from 'zod';
export function toUTCMidnight(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}
export function startOfDay(date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
}
/** Completed years from `date` to `today`: an age from a birth date, a seniority from an entry date. */
export function fullYearsSince(date, today = new Date()) {
    if (!date)
        return null;
    const years = today.getUTCFullYear() - date.getUTCFullYear();
    const monthDiff = today.getUTCMonth() - date.getUTCMonth();
    const hadAnniversary = monthDiff > 0 || (monthDiff === 0 && today.getUTCDate() >= date.getUTCDate());
    return hadAnniversary ? years : years - 1;
}
export function zDateField(message) {
    return z.preprocess((val) => (val == null || val === '' ? undefined : val), z.coerce.date({ message }).transform((date) => startOfDay(date)));
}
export function endOfDay(date) {
    const normalized = new Date(date);
    normalized.setUTCHours(23, 59, 59, 999);
    return normalized;
}
export function addDays(date, days) {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + days);
    return result;
}
export function checkDateOverlap(start1, end1, start2, end2) {
    return areIntervalsOverlapping({ start: startOfDay(start1), end: startOfDay(end1) }, { start: startOfDay(start2), end: startOfDay(end2) }, { inclusive: true });
}
export function getOneWeekAgoDate() {
    const oneWeekAgo = subWeeks(new Date(), 1);
    return startOfDay(oneWeekAgo);
}
